import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    category: {
      title: 'よくあるご質問'
    },
    content: {
      menu: '一覧'
    }
  },
  ra: {
    ...jaMessages.ra
  },
  required: '入力してください',
  'too small': '文字数が不足しています',
  'too large': '文字数が多すぎます',
  'Expected string, received null': '入力必須です',
  'cannot download summary': '取得できません',
  'invalid syntax': '不正な形式です',
  'uploading pdf': 'PDFファイルを送信中',
  'cannot upload pdf': 'PDFファイルを送信できません',
  'downloading pdf': 'PDFファイルを取得中',
  'cannot download pdf': 'PDFファイルを取得できません',
  retrying: '同意申込を再実行中',
  'failed retry': '同意申込の再実行を完了できません'
}
